import { createSlice } from '@reduxjs/toolkit';

import {
  applySessionTokenPayload,
  createEmptySessionTokensState,
  type SessionTokenPayload,
  type SessionTokensState,
} from './sessionTokensSliceShared';

export type UserSessionState = SessionTokensState;

const initialState = createEmptySessionTokensState();

const userSessionSlice = createSlice({
  name: 'userSession',
  initialState,
  reducers: {
    setUserSessionTokens(state, action: { payload: SessionTokenPayload }) {
      applySessionTokenPayload(state, action.payload);
    },
    clearUserSession: () => createEmptySessionTokensState(),
  },
});

export const { setUserSessionTokens, clearUserSession } = userSessionSlice.actions;
export default userSessionSlice.reducer;
